import Vue from 'vue'
import VeeValidate,{ Validator } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN'

Vue.use(VeeValidate);

//提示语汉化
Validator.locale ==="en" ? "zh_CN" : "en";
Validator.localize(Validator.locale,{
    messages:{
        ...zh_CN.messages
    },
    attributes:{
        name: '姓名',
        mobile:'手机号',
        email:'邮箱',
        league: '加盟方式',
        cooperation: '合作方式',
        cooperationDetail: '合作方案'
    }
});



// WEBPACK FOOTER //
// ./src/validator/index.js